import {useCallback} from "react";
import {
  EducationSessionResultsPDFData,
  generateEducationSessionResultsReportPDF,
} from "../../../utils/player/results.pdfGenerator";
import {useTranslation} from "react-i18next";
import EditItemDropdown from "../../EditItemDropdown";

export type Props = Omit<React.ComponentProps<typeof EditItemDropdown.Action>, "onClick" | "as"> &
  EducationSessionResultsPDFData;

export default function ReportSaveDropdownAction({
  user,
  challenge,
  actions,
  additionalScenarios,
  results,
  resultDescriptions,
  parametricResultDescriptions,
}: Props) {
  const {t} = useTranslation();
  const handleDownloadPDF = useCallback(() => {
    generateEducationSessionResultsReportPDF(
      {
        user,
        challenge,
        actions,
        additionalScenarios,
        results,
        resultDescriptions,
        parametricResultDescriptions,
      },
      t,
    );
  }, [user, challenge, actions, additionalScenarios, results, resultDescriptions, parametricResultDescriptions, t]);

  return (
    <EditItemDropdown.Action title={t("components.ReportSaveDropdownAction.title")} onClick={handleDownloadPDF} />
  );
}
